/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Value_FixedInputs */

const cs_field_value_fixed = /** @type {(inputs: Field_Value_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pevná hodnota`)
};

const en_field_value_fixed = /** @type {(inputs: Field_Value_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed`)
};

/**
* | output |
* | --- |
* | "Fixed" |
*
* @param {Field_Value_FixedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_value_fixed = /** @type {((inputs?: Field_Value_FixedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Value_FixedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_value_fixed(inputs)
	return cs_field_value_fixed(inputs)
});